export const BaseUrl = 'https://cityhotel.onrender.com';